module.exports = __webpack_public_path__ + "92c1612798607da4e310315bafc885bf.pdf";